// Vars //
var $body = jQuery('body');

// Change Navigation on scroll
function navOnScroll() {
    var $body = jQuery("body");
    var $navigation = $body.find('header.primary-navigation');
    var $screenTop = jQuery(document).scrollTop();

    /**
     * Add Class to body
     * Fix page refresh issue.
     */
    if ($screenTop >= 100) {
        $body.addClass("scrolled");
        $navigation.addClass("fixed");
    } else {
        $body.removeClass("scrolled");
        $navigation.removeClass("fixed");
    }

    /**
     * Add Class to body
     * on page scroll to alter navigation
     */
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) {
            $body.addClass("scrolled");
            $navigation.addClass("fixed");
        } else {
            $body.removeClass("scrolled");
            $navigation.removeClass("fixed");
        }
    });

}

function backToTop() {
    var body = jQuery("body");
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();

        if (scroll >= 100) {
            body.addClass("show-scroll-to-top");
        } else {
            body.removeClass("show-scroll-to-top");
        }
    });
}

// Header Slider - Setup Function
function sliderSetup() {
    jQuery('.slider-container.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Product Slider
 * Used for multiple blocks - Feature Product Slider, Feature Category Product Slider
 * 
 */
function featureProductSliderSetup() {
    jQuery('.feature-product-slider-container .slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.feature-product-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow, slidesToScroll;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1600) {
            slidesToShow = 4;
            slidesToScroll = 1;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
            slidesToScroll = 1;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            slidesToScroll = 1;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            slidesToScroll = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Content Block Slider
 * 
 */
function contentBlockSliderSetup() {
    jQuery('.slider-content-block.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.slider-content-block');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Logo Slider Block - sc-logo-slider-block.twig
 * 
 */
function logoSliderBlockSetup() {
    jQuery('.logo-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.logo-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow = 1,
            slidesToScroll = 1;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }


        if (jQuery(window).width() > 1600) {
            slidesToShow = 6;
        } else if (jQuery(window).width() > 1400) {
            slidesToShow = 4;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

//did-you-know-slider-container
function didYouKnowSlider() {
    jQuery('.did-you-know-slider-container.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.did-you-know-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            $currentSlideContainer = $dots.find('.current-slide');
            $totalSlidesContainer = $dots.find('.total-slides');
            dots = true,
            infinite = true
            ;

        var sliderCounter = function (slick, currentIndex) {
            $currentSlide = slick.slickCurrentSlide() + 1;
            $slidesCount = slick.slideCount;

            $currentSlideContainer.text('0' + $currentSlide);
            $totalSlidesContainer.text('0' + $slidesCount);
        };
        
        $slider.on('init', function (event, slick) {
            sliderCounter(slick);
        });

        $slider.on('afterChange', function (event, slick, currentSlide) {
            sliderCounter(slick, currentSlide);
        });

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            vertical: true,
            verticalSwiping: true,
            verticalScrolling: true,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-arrow-up"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-arrow-down"></i></span></a>'
        });
    });
}